<template>
  <div>
    <el-dialog
      :title="params.title"
      :visible.sync="isShowDialog"
      :close-on-click-modal="false"
      width="400px"
      @closed="onDialogClosed"
    >
      <div style="color:red;max-height:500px;overflow:auto;">
        <p v-for="(item, index) in params.content" :key="index" style="margin: 7px 0;">
          {{ item.message }}
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button ref="confirmBtn" type="primary" size="small" :autofocus="true" @click="onConfirm">{{ params.confirmText }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowDialog: false,
      params: {}
    }
  },
  methods: {
    openDialog(params) {
      this.params = { ...params }
      this.isShowDialog = true
      if (params.time) {
        setTimeout(() => {
          this.isShowDialog = false
        }, params.time)
      }
    },
    onConfirm() {
      this.isShowDialog = false
      this.onDialogClosed()
    },
    onDialogClosed() {
      this.params.callback()
    }
  }
}
</script>
<style lang='scss'>
</style>
